fx.ns("shared", class BookMain extends shared.BaseMain {

	constructor() 
	{
		super(new repositories.BookRepository());

        this.model.iaEnabled = this.ia;
        this.model.convertPicture = this.is3d ? "3d" : "";
	}

    // if url is /create/magic we create a magic album
	get ia()
	{
        return fx.browser.urlPathParts[1] == "magic";
	}

    // if url is /create/3D we create a 3d album
	get is3d()
	{
		return fx.browser.urlPathParts[1] == "3d";
	}

    onLeave(e)
	{
        // if creating magic book, no need to stop user from leaving
		if (this.ia) return;

        super.onLeave(e);
    }
	
});